import useNavigator from "@saleor/hooks/useNavigator";
import useUser from "@saleor/hooks/useUser";
import React, { useState } from "react";

import { useBrandQuery } from "./../../queries";
import BusinessDetailsView from "./../BusinessDetailsView";
import BrandCreatePage from "./BrandCreatePage";
import BrandUpdatePage from "./BrandUpdatePage";

export interface BusinessPageFormData {
  swornDeclarationsFlag: boolean;
  name: string;
  legalName: string;
  tinNo: string;
  completeAddress: string;
  signatoryName: string;
  signatoryDesignation: string;
  signatoryEmail: string;
  signatoryMobileNo: string;
  bankName: string;
  bankAccountName: string;
  bankAccountNo: string;
  financeName: string;
  financeEmail: string;
  financeMobileNo: string;
  storeType: string;
}

export const BusinessDetailsPage: React.FC = () => {
  const { user } = useUser();
  const navigate = useNavigator();

  const initBrand =
    user.accessGroup &&
    user.accessGroup.accesses.filter(access => access.accessType === "BRAND");
  const brandID =
    initBrand && initBrand[0].privateObjectId
      ? initBrand[0].privateObjectId
      : "";
  const [hasBrand, setHasBrand] = useState(brandID);
  let brandComponent = null;
  const { data: brand } = useBrandQuery({
    displayLoader: true,
    variables: {
      id: hasBrand
    }
  });
  const hasSellerMaster = user.permissionGroups.filter(
    permission => permission.smopUsertypeCode === "SELLER_MASTER"
  );
  if (!hasSellerMaster.length) {
    navigate("/");
  }
  if (
    brand &&
    brand.brandPrivate &&
    brand.brandPrivate.id &&
    brand.brandPrivate.status === "ACT"
  ) {
    brandComponent = <BusinessDetailsView brand={brand.brandPrivate} />;
  } else if (
    brand &&
    brand.brandPrivate &&
    brand.brandPrivate.id &&
    brand.brandPrivate.status === "RVW"
  ) {
    brandComponent = <BrandUpdatePage onBack={undefined} brand={brand} />;
  } else {
    brandComponent = (
      <BrandCreatePage onBack={undefined} setHasBrand={setHasBrand} />
    );
  }
  return brandComponent;
};
export default BusinessDetailsPage;
